import { ArrowUpRight } from 'lucide-react'
import { cn } from '../utils/cn'
import FormularioRD from '../rdstation/formularioRD'
import { useModal } from '../contexts/ModalContext'

export default function BadgetRoxo({
  titulo,
  textoBotao,
  linkBotao,
  className,
}) {
  const { openModal } = useModal();
  return (
    <div
      className={cn(
        'bg-[#2A0D5D] rounded-[30px] py-4 px-8 gap-14 flex items-center w-fit',
        className,
      )}
    >
      <p className="text-xl font-light">{titulo}</p>
      <button
        onClick={() => openModal(<FormularioRD />)}
        type="button"
        className="bg-[#A800E4] flex items-center gap-2.5 rounded-full py-2 px-16 text-sm w-fit cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
      >
        {textoBotao}
        <ArrowUpRight />
      </button>
    </div>
  )
}
